// extracted by mini-css-extract-plugin
export default {"googleLoginContainer":"GoogleLoginButton_googleLoginContainer__n9LHv","googleButton":"GoogleLoginButton_googleButton__Y3o0V"};